import 'reflect-metadata';
import {IsBoolean, IsNumber, IsString, Length, ValidateNested} from 'class-validator';
import {Expose, Type} from 'class-transformer';

class CreateRoleDataClass {
  @IsString()
  @Length(1, 100)
  @Expose()
  name: string;

  @IsString()
  @Length(0, 500)
  @Expose()
  description?: string;

  @Type(() => RolePermissionsCreateEditDataClass)
  @Expose()
  @ValidateNested({each: true})
  permissions?: RolePermissionsCreateEditDataClass[];

}

class UpdateRoleDataClass {
  @IsString()
  @Length(1, 100)
  @Expose()
  name?: string;

  @IsString()
  @Length(0, 500)
  @Expose()
  description?: string;

  @Type(() => RolePermissionsCreateEditDataClass)
  @Expose()
  @ValidateNested({each: true})
  permissions: RolePermissionsCreateEditDataClass[];

  @IsBoolean()
  @Expose()
  isActive?: boolean = true;
}

class RolePermissionsCreateEditDataClass {
  @Expose()
  @IsNumber()
  id?: number; // undefined for edit

  @Expose()
  @IsNumber()
  applicationModuleId: number;

  @Expose()
  @IsBoolean()
  create: boolean = false;

  @Expose()
  @IsBoolean()
  read: boolean = false;

  @Expose()
  @IsBoolean()
  update: boolean = false;

  @Expose()
  @IsBoolean()
  delete: boolean = false;

  @Expose()
  @IsBoolean()
  list: boolean = false;
}

class AssignRoleDataClass {
  @IsNumber()
  @Expose()
  accountId: number;

  @IsNumber()
  @Expose()
  roleId: number;
}

export class Roles {
  public static Endpoints = {
    BaseRoute: 'roles',
    UserRoles: 'accounts/roles'
  };

  public static Permissions = {
    List: 'List',
    Create: 'Create',
    Update: 'Update',
    Delete: 'Delete',
    Read: 'Read'
  }

  public static CreateRoleData = CreateRoleDataClass;
  public static UpdateRoleData = UpdateRoleDataClass;
  public static AssignRoleData = AssignRoleDataClass;

  public static RolePermissions = RolePermissionsCreateEditDataClass;
}
